import {
  GroupByMode,
  ID,
  LifeArea,
  LocalizedLifeArea,
  ReorderSectionUpdate,
  UpdateLifeArea,
} from '@griply/types';

import {
  buildCustomTaskOrderReorderPatch,
  buildSectionReorderPatch,
} from './build-linked-item-reorder-patch';

export type BuildLifeAreaReorderUpdateOptions = {
  lifeArea: LifeArea | LocalizedLifeArea;
  updatedSections: ReorderSectionUpdate[];
  groupBy: GroupByMode | undefined | null;
  // In Section mode the root pseudo-section carries the section order.
  rootSectionId: ID;
  // In Section mode the "no section" bucket carries the flat taskSorting.
  noGroupingSectionId: ID;
};

export const buildLifeAreaReorderUpdate = ({
  lifeArea,
  updatedSections,
  groupBy,
  rootSectionId,
  noGroupingSectionId,
}: BuildLifeAreaReorderUpdateOptions): UpdateLifeArea | null => {
  const groupByMode = groupBy ?? GroupByMode.Section;

  if (groupByMode === GroupByMode.Section) {
    return buildSectionReorderPatch({
      container: lifeArea,
      updatedSections,
      rootSectionId,
      noGroupingSectionId,
    });
  }

  return buildCustomTaskOrderReorderPatch({
    container: lifeArea,
    updatedSections,
    groupByMode,
    rootSectionId,
  });
};
